<template> 
    <div
      class="modal fade"
      id="margin_modal"
      tabindex="-1"
      aria-hidden="true"
      ref="addAIVoucherModalRef"
    >
      <!--begin::Modal dialog-->
      <div class="modal-dialog modal-dialog-centered mw-650px">
        <!--begin::Modal content-->
        <div class="modal-content">
          <!--begin::Modal header-->
          <div class="modal-header" id="kt_modal_add_customer_header">
            <!--begin::Modal title-->
            <div class="col-7 d-flex">
              <!-- <div class="row" v-if="AICode">
                <div class="col-6">
                  <h2 class="fw-bolder" >ใบรับมัดจำ  </h2> 
                </div>
                <div class="col-4">
                  <span style="font-size: 14px !important;">{{AICode}}</span>
                </div>
              </div> -->
              <h2  v-if="AICode">ใบรับมัดจำ {{AICode}} </h2>  &nbsp;&nbsp;   
              <div class="pt-1" style="font-size: 12px; color: #a1a5b7" v-if="AIData && AIData.aiDate">[{{formatDateFromISO(AIData.aiDate)}}]</div> &nbsp; 
              <div  v-if="AICode && AIData.aiIsPosted"><order-status status="posted"></order-status></div>         
              <h2 class="fw-bolder"  v-if="!AICode">เพิ่มใบรับมัดจำ</h2>
             
            </div>             
            <div class="col-5 d-flex justify-content-end"  v-if="AICode">
               <div class="col-4">
                  <PrintAIVoucherButton                  
                    :disabled="!AIData|| !AIData.aiCode || AIData.aiIsCanceled"
                    :aiCode="AIData && AIData.aiCode" 
                    :aiBranchID="AIData && AIData.aiBranchID"
                    :srCode="AIData && AIData.aiRemark">
                  </PrintAIVoucherButton>
               </div>
               <div class="col-5">
                  <button class="btn  btn-sm  btn-danger"  :disabled="!AIData|| !AIData.aiCode|| AIData.aiIsCanceled || SelectedSr.canceled|| SelectedSr.isOrdered"  @click="cancelAI">
                    <i class="fas fa-trash"></i>
                    ยกเลิก
                  </button>
                  <!-- <button class="btn  btn-sm  btn-danger"  v-if="AIData.aiIsPosted" :disabled="!AIData|| !AIData.aiCode|| AIData.aiIsCanceled || SelectedSr.canceled|| SelectedSr.isOrdered"  @click="cancelAI">
                    <i class="fas fa-trash"></i>
                    ยกเลิกเอกสาร
                  </button>      -->
               </div>
            </div> 
            
              

            <!--end::Modal title-->

            <!--begin::Close-->
            <!-- <div
              id="kt_modal_add_customer_close"
              data-bs-dismiss="modal"
              class="btn btn-icon btn-sm btn-active-icon-primary"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div> -->
            <!--end::Close-->
          </div>
          <!--end::Modal header-->
          <!--begin::Modal body-->
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            class="demo-ruleForm"
            label-width="160px"
          >
            <div class="modal-body py-2 px-lg-10">
              <!--begin::Scroll-->
              <div
                class="scroll-y me-n7 pe-7"
                id="kt_modal_add_customer_scroll"
                data-kt-scroll="true"
                data-kt-scroll-activate="{default: false, lg: true}"
                data-kt-scroll-max-height="auto"
                data-kt-scroll-dependencies="#kt_modal_add_customer_header"
                data-kt-scroll-wrappers="#kt_modal_add_customer_scroll"
                data-kt-scroll-offset="300px"
              >
                <el-form-item label="ใบกำกับภาษี"  prop="customerAddressID">
                    <el-row align="">
                      <div v-if="!( customerTaxName) && !AICode">
                        <el-button type="primary" native-type="button" plain @click="openCustomerAddressModal">เลือกที่อยู่ออกบิล</el-button>
                      </div>
                      <div v-if="( customerTaxName) || AICode">
                        <el-form-item >
                          <div class="d-flex">
                            <div class="w-180px me-5">ชื่อ</div>
                            <div class="w-300px fw-bolder">{{ customerTaxName }}</div>
                             <button
                                v-if=" customerTaxName&& !AICode"
                                class="btn btn-link text-primary "
                                type="button"
                                @click="openCustomerAddressModal"
                              >
                                <!-- <i class="bi bi-pencil-square mt-1"></i> -->
                                  แก้ไข
                              </button>
                          </div>
                          <div class="d-flex">
                            <div class="w-185px me-5">ที่อยู่</div>
                            <div  class="fw-bolder">{{ customerTaxAddress }}</div>
                          </div>
                          <div class="d-flex" v-if="(customerTaxID&&customerTaxID.trim() != '')" >
                            <div class="w-180px me-5">
                              เลขประจำตัวผู้เสียภาษี
                            </div>
                            <div  class="fw-bolder">
                              {{ customerTaxID }} &nbsp; &nbsp;
                              {{
                                !customerTaxBranch ||
                                customerTaxBranch.trim() === ""
                                  ? "สำนักงานใหญ่"
                                  : customerTaxBranch
                              }}
                            </div>
                          </div>
                        </el-form-item  >
                      </div>
                     
                    </el-row>
                </el-form-item>
                
               
                <el-form-item
                  label="รับเงินทั้งสิ้น"
                  prop="totalIncVat"
                  style="margin-bottom: 17px"                  
                  
                >
                  
                  <div class="d-flex" v-if="!AICode">
                    <div class="w-170px fw-bolder me-5 m-0">
                      <!-- <el-input-number class="d-flex"
                        v-model="ruleForm.totalIncVat"
                        @change="calculate"                    
                      >
                      </el-input-number> -->
                      <!--  :max="paymentTotal" :min="minimumPayment" -->
                        <NumberInput 
                        v-model="ruleForm.totalIncVat" :not-check-input="true"  @blur="calculate(ruleForm.totalIncVat)" />
                        <div class="text-danger text-center" style="font-size:12px;font-weight:300 !important;">[ Min:{{numberWithCommas(minimumPayment,2)}} ]   ||  [ Max:{{numberWithCommas(paymentTotal,2)}} ] </div>
                    </div>
                    <div>บาท</div>                   
                  </div>                  
                  <div class="d-flex" v-else>
                    <div class="w-130px fw-bolder me-5">{{numberWithCommas(ruleForm.totalIncVat,2)}}</div>
                    <div>บาท</div>
                  </div>
                  <div v-if="errorText !== null"  class="text-danger " style="font-size:13px;font-weight:300 !important;"> {{ errorText }}</div>
                </el-form-item>
                <!-- <span class="text-danger"> {{validateTotalText}}</span> -->
                <el-form-item
                  :label="labelVat"
                  prop="VatRate"
                  style="margin-bottom: 17px"
                >
                  <div class="d-flex" v-if="!AICode">
                    <div class="w-170px fw-bolder me-5">
                      <el-input
                        v-model="ruleForm.vat"
                        :disabled="true" 
                        :input-style="{'text-align': 'right'} "                          
                      >
                      </el-input>
                    </div>
                    <div>บาท</div>
                  </div>
                  <div class="d-flex" v-else>
                    <div class="w-130px fw-bolder me-5">{{numberWithCommas(ruleForm.vat,2)}}</div>
                    <div>บาท</div>
                  </div>

                </el-form-item>
                <el-form-item
                  label="จำนวนเงินสุทธิ"
                  prop="totalExcVat"
                  style="margin-bottom: 17px"
                >
                  <div class="d-flex" v-if="!AICode">
                    <div class="w-180px fw-bolder me-5">
                      <el-input
                        v-model="ruleForm.totalExcVat"
                        :disabled="true"   
                        :input-style="{'text-align': 'right'} "                   
                      >
                      </el-input>
                    </div>
                    <div>บาท</div>
                  </div>
                  <div class="d-flex" v-else>
                    <div class="w-130px fw-bolder me-5">{{numberWithCommas(ruleForm.totalExcVat,2)}}</div>
                    <div>บาท</div>
                  </div>
                </el-form-item>
                <!-- <el-form-item
                  label="จำนวนเงินทั้งหมด"
                  style="margin-bottom: 17px"
                >
                  <div class="d-flex" v-if="!AICode">
                    <div class="w-180px fw-bolder me-5">
                      <el-input
                        v-model="ruleForm.total"
                        :disabled="true"   
                        :input-style="{'text-align': 'right'} "                   
                      >
                      </el-input>
                    </div>
                    <div>บาท</div>
                  </div>
                  <div class="d-flex" v-else>
                    <div class="w-130px fw-bolder me-5">{{ruleForm.total}}</div>
                    <div>บาท</div>
                  </div>
                </el-form-item> -->
                <!-- <el-form-item
                  label="หักยอดชำระแล้ว"
                  style="margin-bottom: 17px"
                >
                  <div class="d-flex" v-if="!AICode">
                    <div class="w-180px fw-bolder me-5">
                      <el-input
                        v-model="paymentTotal"
                        :disabled="true"   
                        :input-style="{'text-align': 'right'} "                   
                      >
                      </el-input>
                    </div>
                    <div>บาท</div>
                  </div>
                  <div class="d-flex" v-else>
                    <div class="w-130px fw-bolder me-5">{{paymentTotal}}</div>
                    <div>บาท</div>
                  </div>
                </el-form-item> -->
                <el-form-item
                  label="แนบหลักฐานการชำระ"
                >
                <div v-if="AICode"  class="col-8">
                              
                  <div v-if="AIData.aiSlipURL">                  
                    <img :src="image" style="width: 155px; height: 185px" />
                  </div>
                  <div v-else>
                        <label>ไม่มีรูปหลักฐานการชำระเงิน</label>
                  </div>
                </div>    
                <div v-else  class="col-8">
                  <div v-if="!image" class="d-flex justify-content-center align-items-center" style="width: 10rem; height: 10rem; border-style: dashed; border-radius: 10px; border-color: rgb(206, 212, 218); text-align: center">
                    <label class="btn btn-default"><i class="fas fa-upload" style="font-size: 5rem; color: rgb(206, 212, 218);"></i> 
                      <input type="file" accept="image/*" hidden="hidden" @change="selectFileChange">
                    </label>
                  </div>                
                  <div v-if="image" style="text-align: center;">
                  
                    <label class="btn btn-default"><img :src="image" style="width: 155px; height: 185px" />
                    <input type="file" accept="image/*" hidden="hidden" @change="selectFileChange">
                    </label>
                    <!-- <br><br> -->
                    <!-- <button v-if="image" @click="removeImage">ลบ</button> -->
                  </div>
                  <!-- <label>แนบหลักฐานการชำระ(.png, .jpg, .jpeg)</label> -->
                </div>    
                </el-form-item>
                <el-form-item
                  label="คำอธิบาย(ภายใน)"
                  prop="aiDetail"
                  style="margin-bottom: 13px"
                >
                  <el-input
                    type="textarea"
                    placeholder=""
                    v-model="ruleForm.detail"
                    maxlength="200"
                    show-word-limit
                    rows="3"
                    class="w-130px"                  
                    v-if="!AICode"
                  >
                  </el-input>
                  <label v-else>{{ruleForm.detail}}</label>
                </el-form-item>
                <el-form-item
                  label="อ้างอิง"
                  prop="remark"
                  style="margin-bottom: 13px"
                >
                 <label>{{ruleForm.remark}}</label>
                  
                </el-form-item>
              </div>
              
              <!--end::Scroll-->
            </div>
            <!--end::Modal body-->
            <div class="modal-footer">
              <button
                class="btn btn-light-primary me-3"
                type="reset"
                @click="hide"
                style="width: 150px"
              >
                ปิด
              </button>
              <el-button
                style="width: 150px"
                type="primary"
                :loading="btnAddCustomerLoading"
                :disabled="
                  (isHavePhone && !isTaxID) ||
                  (isHavePhone && isTaxID && isHaveTaxID)
                "
                @click="submitForm('ruleForm')"
                v-if="!AICode"
              >
                {{
                  btnAddCustomerLoading == true ? "กรุณารอสักครู่..." : "บันทึก"
                }}
              </el-button>
            </div>
          </el-form>
        </div>
        <!--begin::Modal content-->
      </div>
      <!--begin::Modal dialog-->
      
      <search-customer-address-modal v-if="SelectedSr"
      ref="customerAddressModal"
      @select="onSelectAddress"
      :customerId="SelectedSr.customerID"
    ></search-customer-address-modal>
    </div>
</template>

<script>
import ApiService from "@/core/services/ApiService";
import { Modal } from "bootstrap";
import { numberWithCommas, formatDateFromISO, formatDateThDate } from "@/utils";
import Swal from "sweetalert2/dist/sweetalert2.js";
import SearchCustomerAddressModal from "@/components/modals/search/SearchCustomerAddressModal";
import NumberInput from '@/components/forms/NumberInput'
import PrintAIVoucherButton from '@/components/forms/PrintAIVoucherButton.vue';
import OrderStatus from '@/components/status/OrderStatus.vue';

export default {
  props: {
    SelectedSr: Object,
    AICode: String,
    _AIData:Object
  }, 
  components: {
   SearchCustomerAddressModal,
   NumberInput,
   PrintAIVoucherButton,
   OrderStatus
  },
  data() {
    return {
      labelVat:"",
      validateTotalText:"",
      isDisabledButtonSubmit: false,
      isAddressNew: false,
      isCustomer2S: false,
      isDisabledInput: false,
      isHavePhone: false,
      isHaveTaxID: false,
      isTaxID: false,
      ssCustomerID: 0,
      customer: [],
      provinces: [],
      amphurs: [],
      district: [],
      customerTaxName: null,
      customerTaxAddress: null,
      customerTaxID: null,
      customerTaxBranch: null,
      customerAddressID: null,
      ruleForm: {
        customerBillName: "",
        customerBillAddress: "",
        customerBillAmphurID:0,
        customerBillProvinceID:0,
        customerBillZipCode:"",
        customerTaxID: "",
        customerOfBranch: "",
        totalExcVat:null,
        vatRate:null,
        vat:null,
        totalIncVat:null,
        remark:"",
        aiDate:"",
        slipImage:"",        
        slipURL:"",
        detail:"",
        total:0


      },
      aiList:[],
      image:"",
      imageType:"",
      fileUpload: {
          Base64String: "",
          Code: "",
          PriceTotal: 0,
          Remark: "",
      },
      rules: {
        customerBillName: [
          { required: true, message: "กรุณากรอกชื่อออกบิล", trigger: "blur" },
        ],
        customerBillAddress: [
          { required: true, message: "กรุณากรอกที่อยู่ออกบิล", trigger: "blur" },
        ],
        totalIncVat: [
          { required: (!this.AICode), message: "กรุณากรอกรับเงินทั้งสิ้น", trigger: "blur" },
        ],
        customerTaxID: [
          { required: (!this.AICode), message: "กรุณากรอกข้อมูลใบกำกับภาษี", trigger: "blur" },
        ],
        
        // customerProvinceID: [
        //   { required: true, message: "กรุณาเลือกจังหวัด", trigger: "blur" },
        // ],
        // customerAmphurID: [
        //   { required: true, message: "กรุณาเลือกอำเภอ", trigger: "blur" },
        // ],
        // customerDistrictID: [
        //   { required: true, message: "กรุณาเลือกตำบล", trigger: "blur" },
        // ],
      },
      addAIVoucherModalRef: null,
      btnAddCustomerLoading: false,
      requestTaxInvoice: true,
      AIData:{},
      errorText:null
    };
  },
  computed: {
      paymentTotal() {
        let summaryAI = 0;
        this.aiList.forEach(val => {
                summaryAI+=  val.aiNetTotal; 
              //console.log(val);
        });
        return (this.ruleForm.total-summaryAI);
        // return  this.aiList.reduce(
        //       (previousValue, currentValue) => {
        //          (this.ruleForm.total - currentValue.aiAmount).toFixed(2);},
        //       0,
        //     );
        // if(this.SelectedSr){
        //    return this.SelectedSr.aiVouchers.reduce(
        //       (previousValue, currentValue) => previousValue + currentValue.totalExcVat,
        //       0,
        //     );
        // }else{
        //   return 0;
        // }
       
      },
      minimumPayment() {
        let summaryAI = 0;
        this.aiList.forEach(val => {
                summaryAI+=  val.aiNetTotal; 
              //console.log(val);
        });
        return (10/100*(this.ruleForm.total-summaryAI));
       
      },


  },
  mounted() {
    this.addAIVoucherModalRef = new Modal(this.$refs.addAIVoucherModalRef); 
    if( this.SelectedSr){
         this.aiList = this.SelectedSr.aiVouchers;
    }
   
   
  },
  methods: {
    numberWithCommas,
    formatDateFromISO,
    hide() {
      this.ruleForm = [];
      this.rules={};
      this.isTaxID = false;
      this.addAIVoucherModalRef.hide();
      this.clearData();
      this.$emit("refreshdata");
      
    },
    show() {
      if(this.SelectedSr){
        this.getAmphur();
        this.getProvince();
        this.getDistrict();
      }
      if(this.SelectedSr && !this.AICode){
          this.ruleForm.remark =this.SelectedSr.srCode;
          this.labelVat = "มูลค่าที่คำนวณภาษี "+this.SelectedSr.vatRate.toString()+"%";
        
          if(this.SelectedSr.customerTaxID){
            this.customerTaxName = this.SelectedSr.customerTaxName;
            this.customerTaxAddress = this.SelectedSr.customerTaxAddress;
            this.customerTaxID = this.SelectedSr.customerTaxID;
            this.customerTaxBranch = this.SelectedSr.customerTaxBranch;
            this.customerAddressID = this.SelectedSr.customerAddressID;
            this.requestTaxInvoice= this.SelectedSr.requestTaxInvoice;
            this.ruleForm.total = this.SelectedSr.total;
            //this.ruleForm.remark = null;
            this.ruleForm.totalIncVat = null;
            this.ruleForm.totalExcVat = null;
          }
          
      }

      if(this.AICode){
        this.getAIData();
      
        
      }
      this.isHavePhone = false;
      this.btnAddCustomerLoading = false;
      this.addAIVoucherModalRef.show();
    },
    clearData() {
      this.customerTaxName= null;
      this.customerTaxAddress= null;
      this.customerTaxID=null;
      this.customerTaxBranch= null;
      this.customerAddressID= null;
      this.image="";
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && !this.errorText) {
          this.AIVoucherCreate();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getAIData: async function () {
      try {
        const { data } = await ApiService.query("aivoucher/Find", {
          params: { AICode: this.AICode,AIBranchID:0},
        });
        this.AIData = data;
        this.ruleForm.remark =this.AIData.aiRemark;
        this.labelVat = "มูลค่าที่คำนวณภาษี "+this.AIData.aiVatRate.toString()+"%";
        this.customerTaxName = this.AIData.aiCustName;
        this.customerTaxAddress = this.AIData.aiAddress;
        this.customerTaxID = this.AIData.aiTaxNo;
        this.customerTaxBranch = this.AIData.aiTaxBranch;
        this.image = this.AIData.aiSlipURL;//"https://www.2smetal.com/Uploads/SlipTransfer/"+this.AIData.aiSlipURL;
        this.ruleForm.totalIncVat = this.AIData.aiNetTotal;
        this.ruleForm.totalExcVat = this.AIData.aiAmount;
        this.ruleForm.vat = this.AIData.aiVatBal;
        this.ruleForm.vatRate = this.AIData.aiVatRate;
        this.ruleForm.detail = this.AIData.aiDetail;
        this.ruleForm.total = this.SelectedSr.total;
      } catch (error) {
        console.log(error);
      }
    },
    AIVoucherCreate: async function () {
      this.btnAddCustomerLoading = true;

      const loader = this.$loading.show();
      if(this.image){
        const { image } = this;
        this.fileUpload.Base64String = image.replace("data:"+this.imageType+";base64,", "");
      }
      
      
      try {
        var tempData;
        if(this.ruleForm.totalExcVat >0){
            if(this.image){
              const { data } = await ApiService.post("AIVoucher/AIVoucherCreate", {
                SrCode: this.SelectedSr.srCode,
                Remark: this.ruleForm.remark,
                AIdetail: this.ruleForm.detail,
                AINetTotal:this.ruleForm.totalIncVat,
                AIAmount:this.ruleForm.totalExcVat,
                AIVatBal:this.ruleForm.vat,
                FileUpload:this.fileUpload,
                CustomerAddressID:this.customerAddressID
              });
              tempData = data;
            }else{
              const { data } = await ApiService.post("AIVoucher/AIVoucherCreate", {
                SrCode: this.SelectedSr.srCode,
                Remark: this.ruleForm.remark,
                AIdetail: this.ruleForm.detail,
                AINetTotal:this.ruleForm.totalIncVat,
                AIAmount:this.ruleForm.totalExcVat,
                AIVatBal:this.ruleForm.vat,
                CustomerAddressID:this.customerAddressID
              }); 
              tempData = data;
            }
              
            if (tempData["success"] == 1) {
              Swal.fire({
                text: "บันทึกข้อมูลใบรับมัดจำเรียบร้อยแล้ว!",
                icon: "success",
                showCancelButton: false,
                showConfirmButton: false,                  
                allowOutsideClick: false,
                timer: 1500,
                // didDestroy: () => {
                //   this.$router.push({name: 'AIVoucherList'})
                // },
              }).then(() => {
                //this.$emit("refreshdata");
                this.hide();
              });
            } else if (tempData["success"] == 0) {
              Swal.fire({
                text: tempData["error_Text"],
                icon: "warning",
                buttonsStyling: false,
                confirmButtonText: "ปิด",
                allowOutsideClick: false,
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              }).then(() => {
                this.ruleForm.partnerCode = "";
                this.ruleForm.AINetTotal = 0;
                this.ruleForm.AIAmount = 0;
                this.hide();
              });
            } else {
              console.log("error");
            }
        }else{
            Swal.fire("", "กรุณากรอกรับเงินทั้งสิ้น" , "warning"); 
        }
        
         
      } catch (error) {
        Swal.fire({
          text: "เกิดข้อผิดพลาด ไม่สามารถเพิ่มข้อมูลได้!",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "ปิด",
          allowOutsideClick: false,
          customClass: {
            confirmButton: "btn btn-primary",
          },
        }).then(() => {
          //this.hide();
        });
      }

      this.btnAddCustomerLoading = false;
      loader.hide();

    },
    
    getProvince: async function () {
      try {
        const { data } = await ApiService.query("provinces");

        this.provinces = data;
      } catch (error) {
        console.log(error);
      }
    },
    getAmphur: async function () {
      try {
        const { data } = await ApiService.query("amphurs");

        this.amphurs = data;
      } catch (error) {
        console.log(error);
      }
    },
    getDistrict: async function () {
      try {
        const { data } = await ApiService.query("district");

        this.district = data;
      } catch (error) {
        console.log(error);
      }
    },
    changeDistrict(data) {
      var dataFilter = [];
      dataFilter = this.district.filter((v) => v.district_id === data);
      this.ruleForm.customerZipCode = dataFilter[0].zipcode;
    },
    selectFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      
      if (!files.length)
        return;
      this.createImage(files[0]);
    },
    createImage(file) {
      // var image = new Image();
      var reader = new FileReader();

      this.imageType = file.type;

      reader.onload = (e) => {
        this.image = e.target.result;
        //console.log("this.image",this.image);
        // this.imageUpload();
      };
      
      reader.readAsDataURL(file);

    },
    calculate (value) {
       console.log("value",value);
       console.log("this.minimumPayment",this.minimumPayment);
        // var tempvalue= value.toFixed(2);
      // if(!this.ruleForm.totalIncVat || this.ruleForm.totalIncVat<=0){
      //   this.errorText ="กรุณากรอกรับเงินทั้งสิ้น";
      //   return;
      // }
      if(value < this.minimumPayment){
        this.errorText = "จำนวนเงินรับมัดจำ ไม่ถึงขั้นต่ำ 10%";
        //  this.ruleForm.totalIncVat= null;
        this.ruleForm.totalExcVat = null;
        this.ruleForm.vat =null;
      }else if(value > this.paymentTotal){
        this.errorText = "จำนวนเงินรับมัดจำ เกินราคาใบเสนอราคา";
        //  this.ruleForm.totalIncVat= null;
        this.ruleForm.totalExcVat = null;
        this.ruleForm.vat =null;
      }else{
        if(value <= this.SelectedSr.total){
            this.ruleForm.totalExcVat = ((value *100)/(100 +this.SelectedSr.vatRate)).toFixed(2);
            this.ruleForm.vat = (value -this.ruleForm.totalExcVat).toFixed(2);
           this.errorText =null;
        // }else if(this.ruleForm.totalIncVat || this.ruleForm.totalIncVat >0){
        //   this.ruleForm.totalIncVat= null;
        //   this.rules.totalIncVat[0].message = "จำนวนเงินรับมัดจำ เกินราคาใบเสนอราคา";
        }
      }
       
        
    },
    openCustomerAddressModal() {      
      this.$refs.customerAddressModal.show();
    },
    onSelectAddress(address) {
      //console.log(address);
      this.customerTaxName = address.custAddrName;
      this.customerTaxAddress = address.custAddrShow;
      this.customerTaxID = address.custAddrTaxID;
      this.customerTaxBranch = address.custAddrTaxBranch;
      this.ssCustomerID = address.ssCustomerID;
      this.customerAddressID = address.custAddrID;
      this.$refs.customerAddressModal.hide();
    },
    cancelAI() {
      if(this.AIData.aiIsCanceled ) return
      //this.isLoading = true;
      Swal.fire({
        icon: 'question',
        title: 'ต้องการยกเลิกใบรับมัดจำเลขที่ '  + this.AIData.aiCode,
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "กลับ"
      })
      .then( resultCanceled => {
        if(resultCanceled.isConfirmed) {          
          this.hide();
          if(this.AIData.aiIsPosted){
            this.$swal.fire({
              title: "ระบุเหตุผลในการขอยกเลิกเอกสาร <br/><span style='font-size:11px;'>(2S ขอสงวนสิทธิ์ในการพิจารณา เนื่องจากรายการนี้มีการบันทึกบัญชีไปแล้ว <br/>อาจจะมีเอกสารที่เกี่ยวข้องอื่นๆเพิ่มเติม)</span>",
              input: 'textarea',
              showCancelButton: true,
              cancelButtonText: "ปิด",
              confirmButtonText: 'บันทึก',
              showLoaderOnConfirm: true,   
              inputValidator: (value) => {
                if (!value) {
                  return 'กรุณาระบุเหตุผล !!!'
                }
              }
            }).then((result) => {
              if (result.isConfirmed) {
                const loader = this.$loading.show();
                var aiBranchID =this.AIData && this.AIData.aiBranchID ?this.AIData.aiBranchID.toString():""; 
                ApiService.query("AIVoucher/AIVoucherReqCancelPost"
                 //+ this.AIData.aiCode + "&AIBranchID=" +aiBranchID + "&Remark=" + `${result.value}` 
                 , {
                    params: { AICode: this.AIData.aiCode,AIBranchID:this.AIData.aiBranchID,Remark:result.value},
                  }
                 )
                  .then((res) => {
                    console.log("res",res);
                    if(res.data["success"] == 1){
                      this.$swal.fire({
                        icon: 'success',
                        text: 'ขออนุมัติยกเลิกใบรับมัดจำแล้ว',
                        timer: 1500,  
                        showConfirmButton: false, 
                        allowOutsideClick: false,         
                      })

                        this.hide();
                    }
                    else
                    {
                      this.$swal.fire({
                        icon: 'error',
                        text: res.data["error_Text"],
                        timer: 1500,  
                        showConfirmButton: false, 
                        allowOutsideClick: false,         
                      })
                    }
                  })
                  .catch(err => {
                    console.log(err)
                  })
                  .finally(() => {
                    loader.hide();
                  });     
                
              }
            }) 

          }else{
            setTimeout(() => {
              ApiService.delete("aivoucher", this.AIData.aiCode)
              .then((res) => {
                //this.srData.canceled = true;
                Swal.fire("สำเร็จ", "ยกเลิกรายการ " +  this.AIData.aiCode, "success");
                this.hide();
                
              })
              .catch((err) => {
                Swal.fire("เกิดข้อผิดพลาด", "", "error");
                if (err.resonse) {
                  console.log(err.resonse);
                }
              })
              .finally(() => {
                this.isLoading = false;
                //loader.hide();
              });
            }, 500);
          }

              
         
        }
      })
    },
   
  },
};
</script>

<style>
.el-form-item__label {
  text-align: left;
}
.modal-footer {
  justify-content: center;
}
.el-icon-search {
  color: #fff;
}
.el-input.is-disabled .el-input__inner {
  color: #606266;
}
.el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
</style>